import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { orange } from '@material-ui/core/colors';
import ClientForm from "./ClientForm";
import ClientThanks from "./ClientThanks";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxWidth: "300px",
  },
  textField: {
    width: "",
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    backgroundColor: "#C34720",
    '&:hover': {
      backgroundColor: orange[900],
    },
  },
}))(Button);

function Contacts(props: any) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [orderOk, setOrderOk] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSendOrder = (val: boolean) => {
    setOrderOk(val)
  }
  return (
    <div className="Contacts">
      <ColorButton onClick={handleOpen} variant="contained" color="primary">{props.text}</ColorButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div style={{display: orderOk ? 'none': 'block'}}>
              <ClientForm handeSend={handleSendOrder} price={props.price} drawing={props.drawing} konfigured={props.konfigured}></ClientForm>
            </div>
            <div style={{display: orderOk ? 'block': 'none'}}>
              <ClientThanks handeSend={handleSendOrder} handleClose={handleClose}></ClientThanks>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default Contacts;
